module.exports = __webpack_public_path__ + "static/media/decrease_arrow.2859105d.svg";